import { createSignal, splitProps } from "solid-js";
import { Select } from "~/components/Forms/Fields/Base/Select";

import type {
  InputOption,
  SchemaOptions,
  SelectPropsWithOptionalOptions,
  ValidationFunc,
} from "~/components/Forms/Fields/Base/InputTypesProps";
import { picklist, safeParse } from "valibot";
import ValidationErrors from "./Base/ValidationErrors";

const LABEL = "Situation familiale";
const HELP = "Correspond à votre situation patrimoniale.";
const IS_REQUIRED_BY_DEFAULT = true;

export const availableOptions: InputOption[] = [
  {
    label: "Marié(e)",
    value: "1",
    name: "marie",
  },
  {
    label: "Célibataire",
    value: "2",
    name: "celibataire",
  },
  {
    label: "Divorcé",
    value: "3",
    name: "divorce",
  },
  {
    label: "Séparé(e)",
    value: "4",
    name: "separe",
  },
  {
    label: "Veuf / Veuve",
    value: "5",
    name: "veuf",
  },
  {
    label: "Union Libre",
    value: "6",
    name: "union-libre",
  },
  {
    label: "Pacsé",
    value: "7",
    name: "pacse",
  },
] as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SFamilleSchema(options?: SchemaOptions) {
  return {
    SFamille: picklist(
      availableOptions.map((o) => o.value),
      "Veuillez sélectionner votre situation familiale",
    ),
  };
}

export function SFamille(props: SelectPropsWithOptionalOptions) {
  const [local, others] = splitProps(props, ["label", "help", "required"]);
  const [validationErrors, setValidationErrors] = createSignal<string[]>([]);

  const validate: ValidationFunc = (input) => {
    const ret = safeParse(SFamilleSchema().SFamille, input);
    ret.success
      ? setValidationErrors([])
      : setValidationErrors(ret.issues.map((issue) => issue.message));
  };

  return (
    <>
      <div class={`form-item-${props.name}`}>
        <Select
          label={local.label || LABEL}
          help={local.help || HELP}
          validateFn={validate}
          required={
            local.required !== undefined
              ? local.required
              : IS_REQUIRED_BY_DEFAULT
          }
          options={availableOptions}
          {...others}
        />
        <ValidationErrors errors={validationErrors()} field={props.name} />
      </div>
    </>
  );
}
